import React from 'react'
import SidebarLogo from './SidebarLogo'
import SidebarMenu from './SidebarMenu'
import packageJson from '../../../package'
import Logout from './Logout';
import Translation from '../Translation/cont/Translation'


const Sidebar = ({cinemaName, showCopyright, onClick, usedRoutes}) => {
    const name = cinemaName ? cinemaName : ''
    const mainMenuItems = usedRoutes
    const showCopyrightClass = showCopyright ? '' : ' hide'

    return (
        <div className="sidebar">
            <div className="sidebar-wrapper">
                <SidebarLogo />
                <p className="navigation-items cinema-name">{name}</p>
                <SidebarMenu menuItems={mainMenuItems} menuClassName="nav" itemClassName="navigation-items"/>
                <div className="container-fluid">
                    {/* <SidebarMenu menuItems={userMenuItems} menuClassName="user-nav" itemClassName="navigation-submenu" /> */}
                    {/* <CinemaChooserContainer /> */}
                    <Logout />
                    
                    <div className={"copyright-wrapper" + showCopyrightClass} onClick={() => onClick()}>
                        <p className="copyright navigation-copyright">
                            &copy; {new Date().getFullYear()} <a href="http://www.kino-app.com" target="_blank">PMKino</a> - {packageJson.version} <br/>
                            developed by <a href="https://planetmutlu.com/" target="_blank">planetmutlu</a> <br/>
                            <Translation id="sidebar_cooperation">in Zusammenarbeit mit</Translation> <br/> 
                            <a href="https://compeso.com/" target="_blank">COMPESO GmbH</a>
                            <span>, </span>
                            <a href="https://www.kinoheld.de/" target="_blank">kinoheld GmbH</a>
                            <span> <Translation id="and">und</Translation> </span>
                            <a href="https://www.mars-edv.de/" target="_blank">Mars EDV</a>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Sidebar